import React from 'react';

const GetFreeCoupon = ({ children, className, onClick, text, ...props }) => {
  return (
    <button className={className} onClick={onClick} {...props}>
      {text}
      {children}
    </button>
  );
};

export default GetFreeCoupon;
